export default "__VITE_PUBLIC_ASSET__e6c93853__"